import React from "react";

export default function OtherOptionRow({ checked, disabled, label, maxLength, onToggle, onTextChange, text }) {
  return (
    <div className={`survey-option other${checked ? " checked" : ""}${disabled ? " disabled" : ""}`}>
      <label>
        <input
          checked={checked}
          disabled={disabled}
          onChange={onToggle}
          type="checkbox"
        />
        <span>{label}</span>
      </label>
      {checked && (
        <div className="survey-other-text-wrap">
          <input
            className="survey-other-text"
            maxLength={maxLength}
            onChange={(event) => onTextChange(event.target.value)}
            type="text"
            value={text}
          />
        </div>
      )}
    </div>
  );
}
